import { updateAdditionalUserInfo } from "app/utils/users";
import React from "react";
import { useNavigate } from "react-router-dom";
import { setUserProfile } from "app/utils/users";
import { signIn } from "../../../../aws/auth";
import { useAuth } from "../../../../aws/AuthContext";
import toast from "react-hot-toast";
import { DASHBOARD_ROUTE } from "app/constants/route";

type Props = {};

const initialValues = {
  formValue: {
    username: "",
    password: "",
  },
};

const useSignInForm = (props: Props) => {
  const navigate = useNavigate();
  const { refreshUser } = useAuth(); // Get the refreshUser function from AuthContext

  const [isLoading, setIsLoading] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [formValue, setFormValue] = React.useState(initialValues?.formValue);
  const [requiresNewPassword, setRequiresNewPassword] = React.useState(false);

  const updateFormValue = (key: string, value: any) => {
    try {
      const newFormValue = { ...formValue, [key]: value };
      setFormValue(newFormValue);
    } catch (err) {}
  };

  const postSignIn = async () => {
    try {
      if (isLoading) return;

      try {
        setIsLoading(true);

        const result = await signIn({
          username: formValue?.username,
          password: formValue?.password,
        });

        console.log("Sign In result: ", result);

        if (result.requiresNewPassword) {
          // User needs to change password
          setRequiresNewPassword(true);
          toast.success("Please set a new password to continue");
        } else if (result.isSignedIn) {
          // Force a refresh of the auth state to ensure we have valid user data
          await refreshUser();
          
          setUserProfile(result.user);
          navigate(DASHBOARD_ROUTE);
        }
      } catch (e) {
        console.error("Sign In Error: ", e);
        // Error handling is now managed in the AWS auth.ts file
        // with the handleAuthError function
      } finally {
        setIsLoading(false);
      }
    } catch (err) {
      console.error("Unexpected error:", err);
    }
  };

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    updateAdditionalUserInfo(formValue);
    setUserProfile(formValue);
    await postSignIn();
  };

  return {
    showPassword,
    setShowPassword,
    formValue,
    updateFormValue,
    isLoading,
    setIsLoading,
    onSubmit,
    requiresNewPassword,
  };
};

export default useSignInForm;
